module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/Tv_mpbile-a2181ab933774f0634ec1057d3ffde45.webp";